module.exports = __webpack_public_path__ + "static/media/thoughts5.90fe13bb.jpg";